<app-users-table [userRoles]="userRoles" [filterED]="ed" [hideEDColumn]="true" [title]="'All Users'" [hideRoleColumn]="true" [hideRoleFilter]="true"></app-users-table>
